module.exports = __webpack_public_path__ + "static/media/medidas_camiseta_p.ba03db9d.png";